<template>
  <footer class="app-footer">
    <div class="container-readable footer-inner">
      <!-- עמודה 1: אודות המותג -->
      <section class="footer-col stack-sm">
        <div class="brand-badge">
          <h3 class="footer-title">BestPhone</h3>
        </div>
        <p class="footer-text">
          פתרונות סלולר מתקדמים עם שירות אישי, שקיפות מלאה ותמיכה מקצועית לאורך כל הדרך.
        </p>
      </section>

      <!-- עמודה 2: קישורים מהירים -->
      <section class="footer-col stack-sm">
        <h4 class="footer-subtitle">קישורים מהירים</h4>
        <nav class="footer-links" aria-label="קישורים מהירים">
          <router-link to="/">
            <svg class="link-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            דאשבורד
          </router-link>
          <router-link to="/change-plan">
            <svg class="link-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            עדכון מסלול ורשת
          </router-link>
          <router-link to="/usage">
            <svg class="link-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            נתוני שימוש
          </router-link>
          <router-link to="/payment-method">
            <svg class="link-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            אמצעי תשלום
          </router-link>
        </nav>
      </section>

      <!-- עמודה 3: יצירת קשר -->
      <section class="footer-col stack-sm">
        <h4 class="footer-subtitle">יצירת קשר</h4>
        <div class="footer-contact-list">
          <div class="contact-item">
            <span class="country-tag">ישראל</span>
            <a href="tel:+97225377544" class="phone-link">02-5377544</a>
          </div>
          <div class="contact-item">
            <span class="country-tag">USA</span>
            <a href="tel:+17186806888" class="phone-link">1-718-680-6888</a>
          </div>
          <div class="contact-item">
            <span class="country-tag">UK</span>
            <a href="tel:+442037699727" class="phone-link">+44 20 3769 9727</a>
          </div>
          <div class="contact-item email-item">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            <a href="mailto:yoely@bestphonekosher.com">yoely@bestphonekosher.com</a>
          </div>
        </div>
      </section>
    </div>

    <!-- חלק תחתון -->
    <div class="footer-bottom">
      <div class="container-readable footer-bottom-inner">
        <p class="copyright">© {{ currentYear }} <strong>BestPhone</strong>. כל הזכויות שמורות.</p>
        <p class="support-text">שירות לקוחות זמין לענות ולעזור לאורך כל הדרך.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped src="@/styles/components/app-footer.scss"></style>